<!-- Breadcrumb -->
<div class="content-breadcrumb div-breadcrumb">
  <em class="fa fa-building icon-breadcrumb"></em>
  <span class="text-breadcrumb">Prestador - Procedimentos</span>
</div>

<div class="container-fluid">
  <div class="row mt-3">
    <div class="d-flex justify-content-end">
      <button type="button" class="btn btn-success float-right" (click)="modalNovoPrestadorProcedimento(content)"> <i class="fa fa-plus"></i> &nbsp; Associar Procedimento</button>
    </div>
  </div>
  <app-card titleCard="Lista dos procedimentos associados">
    <div class="row mb-3">
      <div class="col-12">
        <span class="font-italic text-warning" style="font-size: 13px;">
          Nessa tela você deve associar os procedimentos e valores para o prestador - <strong>{{ prestador.nome }}</strong>
        </span>
      </div>
    </div>
      <div class="table-responsive">
          <table class="table table-bordered table-hover text-center text-table">
              <thead>
                  <tr class="table-active">
                      <th style="width: 150px">ID</th>
                      <th style="width: 180px">Código Proc.</th>
                      <th>Nome</th>
                      <th>Valor</th>
                      <th style="width: 100px">Ações</th>
                  </tr>
               </thead>
              <tbody>
                  <ng-template ngFor let-prestProcedimento
                    [ngForOf]="listaProcedimentosPorPrestador">
                      <tr>
                          <th scope="row">{{ prestProcedimento.id }}</th>
                          <td scope="row">{{ prestProcedimento.procedimentoCodigo }}</td>
                          <td>{{ prestProcedimento.procedimentoNome }}</td>
                          <td>R$ {{ prestProcedimento.valorUnitario | number:'1.2-2' }}</td>
                        <td>
                          <a data-toggle="tooltip" title="Editar Associação">
                              <em class="fa fa-edit icon-table" (click)="modalAlterarPrestadorProcedimento(content, prestProcedimento.id)"></em>
                          </a>&nbsp;
                          <a data-toggle="tooltip" title="Remover Associação">
                              <em class="fa fa-trash icon-table" (click)="modalExclusaoGuia(contentDelete, prestProcedimento.id)"></em>
                          </a>
                      </td>
                      </tr>
                  </ng-template>
              </tbody>
          </table>
      </div>
  </app-card>

  <!-- MODAL PARA CADASTRAR/ALTERAR OS PROCEDIMENTOS E VALORES RELACIONADOS AO PRESTADOR. -->
  <ng-template #content let-closed="close" let-dismiss="dismiss">
      <form #frmPrestProcedimento="ngForm" autocomplete="off" (ngSubmit)="save(frmPrestProcedimento)">
          <div class="modal-header">
            <div class="container row me-0 pe-0">
              <div class="col">
                <h4 class="modal-title">Prestador - Procedimentos</h4>
              </div>
              <div class="col-auto me-0 pe-0">
                <div class="d-flex justify-content-center">
                  <button type="button" class="close" aria-label="Close" (click)="dismiss()">
                      <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <label class="required form-label">Procedimento</label>
                  <ngx-select
                      [items]="listaTodosProcedimentos" optionValueField="id" optionTextField="nome"
                      noResultsFound="Nenhum resultado encontrado" (select)="changeProcedimentoValorUnitario($event)"
                      name="procedimentoId" [(ngModel)]="prestProcedimento.procedimentoId" #prestProcedimentoId="ngModel" required>
                  </ngx-select>
                  <app-message [control]="prestProcedimentoId" error="required" text="Campo obrigatório"></app-message>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label class="required form-label">Valor</label>
                  <input class="form-control" placeholder="R$ 0,00" required currencyMask name="valorUnitario"
                  [(ngModel)]="prestProcedimento.valorUnitario" #procedimentoValor="ngModel" [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"/>
                  <app-message [control]="procedimentoValor" error="required" text="Campo obrigatório"></app-message>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
              <button type="button" ngbAutofocus class="btn btn-secondary" (click)="dismiss('click')">
                <i class="fa fa-times" aria-hidden="true"></i>&nbsp; Cancelar
              </button>
              <button type="submit" class="btn btn-primary" [disabled]="frmPrestProcedimento.invalid">
                <i class="fa fa-check" aria-hidden="true"></i>&nbsp; Salvar
              </button>
          </div>
      </form>
  </ng-template>

  <!-- MODAL DE CONFIRMAÇÃO PARA EXCLUIR A GUIA MÉDICA. -->
  <ng-template #contentDelete let-closed="close" let-dismiss="dismiss">
    <div class="modal-header">
      <div class="container row me-0 pe-0">
        <div class="col">
          <h2 class="modal-title" id="modal-title">Excluir Associação</h2>
        </div>
        <div class="col-auto">
          <div class="d-flex justify-content-end me-0 pe-0">
            <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title" (click)="dismiss('click')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-body">
        <p><strong>Você tem certeza que deseja excluir essa associação de <span class="font-italic">procedimento x prestador</span> ?</strong></p>
        <span class="text-danger">Esta operação não pode ser desfeita.</span>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" ngbAutofocus (click)="dismiss('click')">Cancelar</button>
        <button type="button" class="btn btn-danger" (click)="excluir(identificadorPrestProcedimentoExclusao)">Excluir</button>
    </div>
  </ng-template>
</div>
